// extracted by mini-css-extract-plugin
export default {"servicesMenuItem":"services-menu-item_servicesMenuItem__cn+x6","img":"services-menu-item_img__jA7UO","title":"services-menu-item_title__DaAhM"};